import { SequenceMenu } from '@sequencehq/core-components'
import { useCopyTemplateLink } from './hooks/useCopyTemplateLink'

interface CopyTemplateLinkMenuItemProps {
  quoteTemplateId: string
  disabled?: boolean
}

export const CopyTemplateLinkMenuItem = (
  props: CopyTemplateLinkMenuItemProps
) => {
  const { copyTemplateLink } = useCopyTemplateLink({
    quoteTemplateId: props.quoteTemplateId
  })

  return (
    <SequenceMenu.Item
      uuid="copy-template-link"
      label="Copy link to template"
      data-testid={`quoteTemplates.${props.quoteTemplateId}.menuItem.copyLink`}
      isDisabled={props.disabled}
      onClick={copyTemplateLink}
    />
  )
}
